/* import __COLOCATED_TEMPLATE__ from './workflows-inspect.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type Router from '@ember/routing/router-service';
import type Session from 'embercom/services/session';
import type Conversation from 'embercom/objects/inbox/conversation';
import type SidebarSection from 'embercom/objects/inbox/sidebar-section';
import type Inbox from 'embercom/objects/inbox/inboxes/inbox';
import { type SidebarSectionComponentArgs } from 'embercom/lib/inbox2/sidebar-types';
import type { SupportedSidebarSection } from 'embercom/services/inbox-sidebar-service';
import type InboxSidebarService from 'embercom/services/inbox-sidebar-service';
import safeWindowOpen from 'embercom/lib/safe-window-open';
import moment from 'moment-timezone';

type Args = SidebarSectionComponentArgs<{
  conversation: Conversation;
  sidebarSection: SidebarSection;
  activeInbox?: Inbox;
  onExpandedSectionChange: (sectionId: SupportedSidebarSection | number | undefined) => void;
  previewOnly?: boolean;
}>;

interface Signature {
  Args: Args;
}

export default class WorkflowsInspect extends Component<Signature> {
  @service declare session: Session;
  @service declare router: Router;
  @service declare intercomEventService: any;
  @service declare inboxSidebarService: InboxSidebarService;

  get isVisible() {
    return this.inboxSidebarService.isWorkflowsDebuggerVisible;
  }

  get isConversationOlderThan30Days() {
    let lastPart = this.args.conversation.lastPart;
    if (!lastPart?.createdAt) {
      return false;
    }

    let thirtyDaysAgo = moment().subtract(30, 'days');
    return moment(lastPart.createdAt).isBefore(thirtyDaysAgo);
  }

  @action handleInspectClick() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      section: 'conversation_details_sidebar',
      object: 'workflows_inspect',
      conversation_id: this.args.conversation.id,
    });

    // Navigate to the teammate-app workflows inspect page with the conversation ID
    // The teammate-app is served under the /a/ path
    let inspectUrl = `/a/apps/${this.session.workspace.id}/automation/workflows-troubleshoot/conversations/${this.args.conversation.id}`;

    safeWindowOpen(inspectUrl, '_blank');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::SidebarSections::WorkflowsInspect': typeof WorkflowsInspect;
    'inbox2/conversation-details-sidebar/sidebar-sections/workflows-inspect': typeof WorkflowsInspect;
  }
}
